/* src/app/features/leilao/detalhe-leilao/detalhe-leilao.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=detalhe-leilao.component.css.map */
